import { FileQuestion } from "lucide-react";

import { FileComponentProps } from "../../types";
import { FileThumbnail } from "../FileThumbnail";
import { getFileSizeFromBase64 } from "../../utils";

export const UnknownFileDisplay = ({
  data,
  detectedFile,
}: Omit<FileComponentProps, "isViewing" | "setIsViewing">) => (
  <div className="group relative">
    <div className="cursor-pointer rounded p-2">
      <FileThumbnail
        icon={<FileQuestion className="h-6 w-6 text-gray-600" />}
        title="Unknown File"
        subtitle={`${
          detectedFile.extension?.toUpperCase() || "FILE"
        } • ${getFileSizeFromBase64(data)}`}
      />
    </div>
  </div>
);
